<template>
    <row>
        <column cols="12" md="7" lg="8">
            <card xs-tile no-spacing>
				<activity-feed ref="feedElement"
							   :url="`/v1/users/${userStore.user.id}/activities`"
							   :model="userStore.user" without-create flat/>
			</card>
        </column>
        <column v-if="participationEvents.length" cols="12" md="5" lg="4">
            <sticky-content>
                <card xs-tile sm-tile>
                    <card-title>{{ $t('label.current_events') }}</card-title>
					<card-text class="pb-0">
						<profile-preview v-for="participationEvent in participationEvents" :key="`event-${participationEvent.id}`" :model="participationEvent" outlined/>
					</card-text>
                    <btn :to="$web('users.show.events', userStore.user._key)" replace text :color="userStore.user.color ?? 'primary'"
                         class="rounded-t-none border-t w-full">
                        <span>{{ $t('action.show_all') }}</span>
                        <icon :icon="icons.next"/>
                    </btn>
                </card>
            </sticky-content>
        </column>
    </row>
</template>

<script setup lang="ts">
import {nextIcon} from "@spoferan/nuxt-spoferan/icons";
import {useUserStore} from "../../../store/user";
import {useIndexStore} from "../../../store";
import {PrivacyType} from "@spoferan/spoferan-ts-core";

const userStore = useUserStore();
const {t} = useI18n();
const route = useRoute();
const indexStore = useIndexStore();
const {$device, $auth} = useNuxtApp();

let participationEvents = [];
if (!$device.isMobile && (userStore.user.privacy_events === PrivacyType.Public || (userStore.user.privacy_events === PrivacyType.Community && $auth.loggedIn))) {
	try {
		const {data} = await useApiFetch(`/v1/athletes/${userStore.user.id}/events`, {
			guest: true,
			params: {
				limit: 3
			}
		})
		participationEvents = data;
	} catch (e) {

	}
}

const icons = {
	next: nextIcon,
};

const feedElement = ref(null);

const isFollowing = computed(() => {
	return indexStore.follows.findIndex(follow => follow.type === userStore.user.model_type && follow.id === userStore.user.id) > -1;
});

watch(isFollowing, () => {
	if (feedElement.value) {
		feedElement.value.reload(1, true, false);
	}
});

useMeta({
	title: userStore.buildPageTitle(t('view.users.feed.index.title', {user: userStore.user.display_name})),
	description: t('view.users.feed.index.description', {user: userStore.user.display_name}),
})

</script>

